import React, { useEffect,useState , Suspense } from "react";
import Layout from "../components/SidePane/DashLayout";
import { BeatLoader } from 'react-spinners';

const LazyHomePageComponent = React.lazy(() =>
  import("../components/HomePage")
);
const LazyUserSettings = React.lazy(() =>
  import("../components/Settings/userSettings")
);
const LazyRetrieveTransaction = React.lazy(() =>
  import("../components/RetrieveTransaction")
);
const LazyVendorMaster = React.lazy(() =>
  import("../components/VendorMaster/VendorMaster")
);
const LazyAddVendor = React.lazy(() =>
  import("../components/VendorMaster/AddVendor")
);
const LazyAllUsers = React.lazy(() =>
  import("../components/Settings/AllUsers")
);
const LazyAddUser = React.lazy(() => import("../components/Settings/AddUser"));
const LazyApprovals = React.lazy(() =>
  import("../components/FundTransfer/Transfers/Approvals")
);
const LazyStatus = React.lazy(() =>
  import("../components/FundTransfer/Status")
);
const LazyRejected = React.lazy(() =>
  import("../components/FundTransfer/Rejected")
);
const LazyAuditLog = React.lazy(() => import("../components/AuditLog"));
const LazyTransferComponent = React.lazy(() =>
  import("../components/FundTransfer/Transfers/Transfers")
);


const HomePageLayout = Layout(({...props }) => (
  <Suspense
    fallback={
      <div className="text-center flex justify-center items-center w-full h-screen">
        {" "}
        <BeatLoader  color={"#081A51"} size={15} />
      </div>
    }
  >
    <LazyHomePageComponent {...props} />
  </Suspense>
));

const SettingsLayout = Layout((props) => (
  <Suspense fallback={<div className="text-center flex justify-center items-center w-full h-screen"><BeatLoader  color={"#081A51"} size={15} /></div>}>
    <LazyUserSettings {...props} />
  </Suspense>
));
const RetrieveTransactionLayout = Layout((props) => (
  <Suspense fallback={<div className="text-center flex justify-center items-center w-full h-screen"><BeatLoader  color={"#081A51"} size={15} /></div>}>
    <LazyRetrieveTransaction {...props} />
  </Suspense>
));
const VendorMasterLayout = Layout((props) => (
  <Suspense fallback={<div className="text-center flex justify-center items-center w-full h-screen"><BeatLoader  color={"#081A51"} size={15} /></div>}>
    <LazyVendorMaster {...props} />
  </Suspense>
));
const AddVendorLayout = Layout((props) => (
  <Suspense fallback={<div className="text-center flex justify-center items-center w-full h-screen"><BeatLoader  color={"#081A51"} size={15} /></div>}>
    <LazyAddVendor {...props} />
  </Suspense>
));
const AllUsersLayout = Layout((props) => (
  <Suspense fallback={<div className="text-center flex justify-center items-center w-full h-screen"><BeatLoader  color={"#081A51"} size={15} /></div>}>
    <LazyAllUsers {...props} />
  </Suspense>
));
const AddUserLayout = Layout((props) => (
  <Suspense fallback={<div className="text-center flex justify-center items-center w-full h-screen"><BeatLoader  color={"#081A51"} size={15} /></div>}>
    <LazyAddUser {...props} />
  </Suspense>
));
const TransfersLayout = Layout((props) => (
  <Suspense fallback={<div className="text-center flex justify-center items-center w-full h-screen"><BeatLoader  color={"#081A51"} size={15} /></div>}>
    <LazyTransferComponent {...props} />
  </Suspense>
));
const StatusLayout = Layout((props) => (
  <Suspense fallback={<div className="text-center flex justify-center items-center w-full h-screen"><BeatLoader  color={"#081A51"} size={15} /></div>}>
    <LazyStatus {...props} />
  </Suspense>
));
const RejectedLayout = Layout((props) => (
  <Suspense fallback={<div className="text-center flex justify-center items-center w-full h-screen"><BeatLoader  color={"#081A51"} size={15} /></div>}>
    <LazyRejected {...props} />
  </Suspense>
));
const AuditLogLayout = Layout((props) => (
  <Suspense fallback={<div className="text-center flex justify-center items-center w-full h-screen"><BeatLoader  color={"#081A51"} size={15} /></div>}>
    <LazyAuditLog {...props} />
  </Suspense>
));
const ApprovalsLayout = Layout((props) => (
  <Suspense fallback={<div className="text-center flex justify-center items-center w-full h-screen"><BeatLoader  color={"#081A51"} size={15} /></div>}>
    <LazyApprovals {...props} />
  </Suspense>
));



export {
  HomePageLayout,
  SettingsLayout,
  RetrieveTransactionLayout,
  VendorMasterLayout,
  AddVendorLayout,
  AllUsersLayout,
  AddUserLayout,
  TransfersLayout,
  StatusLayout,
  RejectedLayout,
  AuditLogLayout,
  ApprovalsLayout,
};
